import { WorksheetSchemaSectionGroup } from '../../../../../types/custom-worksheet-v2';
import { sortByOrder } from '../../store/utils';
import FlashBackground from '../FlashBackground';
import Property from '../Property';
import PropertyHeader from '../PropertyHeader';

type SectionGroupProps = {
    sectionGroup: WorksheetSchemaSectionGroup;
    allowRedirect?: boolean;
};

function SectionGroup({ sectionGroup, allowRedirect }: SectionGroupProps): JSX.Element {
    return (
        <div id={sectionGroup.id} className="scroll-mt-8 relative w-full">
            <FlashBackground id={sectionGroup.id} />
            <PropertyHeader property={sectionGroup} headingSize="xl" />
            {/* Show section container when section group is expanded */}
            {Object.keys(sectionGroup.properties).length > 0 && (
                <div className="flex flex-col pl-6 gap-4 pt-4">
                    {sortByOrder(sectionGroup.properties).map((value) => {
                        return <Property key={value.id} value={value} allowRedirect={allowRedirect} />;
                    })}
                </div>
            )}
        </div>
    );
}

export default SectionGroup;
